import {Translations} from "./translations.model";
import {DistanceType} from "../types/distance.type";
import {CoordinatesModel} from "./coordinates.model";

export class PointModel extends CoordinatesModel{
  uid?: string;
  parentUid?: string;
  name?: Translations;
  type?: string[];
  description? : Translations;
  children?: PointModel[];
  distance?: DistanceType;
  images?: string[];

  constructor(that?: PointModel) {
    super();
    if (that) {
      this.uid = that.uid || this.uid;
      this.parentUid = that.parentUid || this.parentUid;
      this.name = that.name || this.name;
      this.type = that.type || this.type;
      this.description = that.description || this.description;
      this.children = that.children || this.children;
      this.distance = that.distance || this.distance;
      this.images = that.images || this.images;
    }
  }
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/models/point.model.ts